export interface UserRakeTotal {
  userId: string;
  totalAmount: number;
  totalCount: number;
}
